import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

Sentry.init({
  dsn: 'https://a237bbef6a0d4695bdb45a8a126a116b@glitchtip.neofluxsystems.net/2',
  environment: 'production',
  release: '1.0.0',
  tracesSampleRate: 0.01,
  autoSessionTracking: false,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

